/* ------------back to top js start---------------*/
  $(window).on("scroll", function () {
        var scrollTop = $(window).scrollTop();
        var docHeight = $(document).height() - $(window).height();
        var scrollPercent = scrollTop / docHeight;
        var circleLength = 2 * Math.PI * 48;
        var offset = circleLength * (1 - scrollPercent);
        $(".progress").css("stroke-dashoffset", offset);
        if (scrollPercent >= 0.15) {
          $('.back-to-top').fadeIn();
        } else {
          $('.back-to-top').fadeOut();
        }
      });
      $('.back-to-top').on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 500); 
      });
/* ------------back to top js end--------------- */
/*------------  hamepage hero banner swiper slider js start -----------------*/
$(document).ready(function () {
  const swiper = new Swiper(".mijooherobanner", {
      loop: true,
      speed: 1200,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
});
/*------------  hamepage hero banner swiper slider js end -----------------*/

/*------------------- testimonial slider design js start -------------------------*/
$(document).ready(function () {
  const slider = document.querySelector(".testimonial-slider");
  const slides = document.querySelectorAll(".slide");
  const dots = document.querySelectorAll(".dot");
  let index = 0;
  let autoSlide = null; 
  function clearAllActive() {
    slides.forEach(slide => slide.classList.remove("active"));
    dots.forEach(dot => dot.classList.remove("active"));
  }
  function showSlide(i) {
    clearAllActive();
    slides[i].classList.add("active");
    dots[i].classList.add("active");
  }
  function nextSlide() {
    index = (index + 1) % slides.length;
    showSlide(index);
  }
  function prevSlide() {
    index = (index - 1 + slides.length) % slides.length;
    showSlide(index);
  }
  function startAuto() {
    stopAuto(); 
    autoSlide = setInterval(nextSlide, 4000);
  }
  function stopAuto() {
    if (autoSlide) {
      clearInterval(autoSlide);
      autoSlide = null;
    }
  }
  function resetSlider() {
    stopAuto(); 
    index = 0;
    showSlide(index);
    startAuto();
  }
  resetSlider();
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      resetSlider();
    }
  });
  slider.addEventListener("mouseenter", stopAuto);
  slider.addEventListener("mouseleave", startAuto);
  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      index = i;
      showSlide(index);
      startAuto(); 
    });
  });
  let startX = 0;
  slider.addEventListener("mousedown", (e) => {
    startX = e.clientX;
  });
  slider.addEventListener("mouseup", (e) => {
    let diff = e.clientX - startX;
    if (diff > 50) prevSlide();
    else if (diff < -50) nextSlide();
  });
  slider.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });
  slider.addEventListener("touchend", (e) => {
    let diff = e.changedTouches[0].clientX - startX;
    if (diff > 50) prevSlide();
    else if (diff < -50) nextSlide();
  });
});
/*------------- testimonial slider design js end ----------------- */

/*------------------- comparisonSection slider for after before image start--------------*/
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.comparison-slider').forEach(section => {
    const swiperEl = section.querySelector('.comparisonSwiper');
    if (!swiperEl) return;
    const swiper = new Swiper(swiperEl, {
      loop: true,
      autoplay: false,
      allowTouchMove: false,
      simulateTouch: false,
      touchStartPreventDefault: false,
    });
    const parent =
      section.closest('.row') ||
      section.closest('.comparison-wrapper') ||
      section.parentElement;
    const nextBtns = parent.querySelectorAll('.comp-next');
    const prevBtns = parent.querySelectorAll('.comp-prev');
    nextBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        swiper.slideNext();
      });
    });
    prevBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        swiper.slidePrev();
      });
    });
  });

  document.querySelectorAll('.slider-container').forEach(container => {
    const handle = container.querySelector('.slider-handle');
    const line = container.querySelector('.slider-line');
    const afterImage = container.querySelector('.after-image');
    if (!handle || !line || !afterImage) return;
    let rect, pct = 0.5, rafId = null;
    let isDragging = false;
    const apply = () => {
      const percent = pct * 100 + '%';
      handle.style.left = percent;
      line.style.left = percent;
      afterImage.style.clipPath =
        `polygon(${percent} 0,100% 0,100% 100%,${percent} 100%)`;
      rafId = null;
    };
    const update = (clientX) => {
      if (!rect) return;
      pct = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
      if (!rafId) rafId = requestAnimationFrame(apply);
    };
    const getX = (e) =>
      e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const start = (e) => {
      e.preventDefault();
      e.stopPropagation(); 
      rect = container.getBoundingClientRect();
      isDragging = true;
      update(getX(e));
      document.addEventListener('mousemove', move);
      document.addEventListener('touchmove', move, { passive: false });
      document.addEventListener('mouseup', end);
      document.addEventListener('touchend', end);
    };
    const move = (e) => {
      if (!isDragging) return;
      e.preventDefault();
      update(getX(e));
    };
    const end = () => {
      isDragging = false;
      document.removeEventListener('mousemove', move);
      document.removeEventListener('touchmove', move);
      document.removeEventListener('mouseup', end);
      document.removeEventListener('touchend', end);
    };
    handle.addEventListener('mousedown', start);
    handle.addEventListener('touchstart', start, { passive: false });
    container.addEventListener('mousedown', (e) => {
      if (e.target === handle) return;
      rect = container.getBoundingClientRect();
      update(e.clientX);
    });
    container.addEventListener('touchstart', (e) => {
      if (e.target === handle) return;
      e.preventDefault();
      rect = container.getBoundingClientRect();
      update(e.touches[0].clientX);
    }, { passive: false });
    window.addEventListener('resize', () => {
      rect = container.getBoundingClientRect();
      apply();
    });
    apply();
  });
});

/*------------------- comparisonSection slider for after before image end--------------*/

/*--------------------- mijoo-hero-ingredients section js start -----------------------*/
$(document).ready(function () {
  var swiper = new Swiper(".ingredient-slider", {
    slidesPerView: 1.1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    speed: 800,
    breakpoints: {
      767: {
        slidesPerView: 1.7,
      },
      1024: {
        slidesPerView: 1.9,
      },
      1200: {
        slidesPerView: 2.5,
      }
    }
  });
});
/*--------------------- mijoo-hero-ingredients section js end -----------------------*/
/*--------------------- quick-video-section section js start -----------------------*/
$(document).ready(function () {
  var swiper = new Swiper(".video-steps-slider", {
    slidesPerView: 1.1,
    spaceBetween: 20,
    loop: true,              
    autoplay: {
      delay: 9000,
      disableOnInteraction: false,
    },
    speed: 800,
    centeredSlides: false,    
    breakpoints: {
      767: {
        slidesPerView: 2.2,
      },
      1024: {
        slidesPerView: 2.5,
      },
      1200: {
        slidesPerView: 3.2,
      }
    }
  });
});

/*--------------------- quick-video-section section js end -----------------------*/
/*-------------------- pdp page review js start -----------------------*/
function updateJudgeMeBadge() {
  document.querySelectorAll('.jdgm-prev-badge').forEach(function(badge) {

    const rating = badge.getAttribute('data-average-rating');
    const reviews = badge.getAttribute('data-number-of-reviews');
    const text = badge.querySelector('.jdgm-prev-badge__text');

    if (text && rating && reviews) {
      text.setAttribute(
        'data-custom-text',
        rating + ' / ' + reviews + ' verified reviews'
      );
    }
  });
}

setInterval(updateJudgeMeBadge, 50);
/*-------------------- pdp page review js end -----------------------*/
/*------------ ----------------- pdp offer div js start ---------------------------------------*/ 

document.addEventListener('DOMContentLoaded', function(){

  const openBtn = document.getElementById('openGuarantee');
  const closeBtn = document.getElementById('closeGuarantee');
  const continueBtn = document.getElementById('continueShopping');
  const drawer = document.getElementById('mbgDrawer');
  const overlay = document.getElementById('mbgOverlay');

  function openDrawer(){
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(){
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  continueBtn.addEventListener('click', closeDrawer);

});
/*------------ ----------------- pdp offer div js end ---------------------------------------*/ 

/*------------  newslatter popup js start -----------------*/
  window.addEventListener('DOMContentLoaded', function () {
    if (!sessionStorage.getItem('mijooPopupShown')) {
      setTimeout(function () {
        const popup = document.getElementById('popup');
        popup.style.display = 'flex';
        sessionStorage.setItem('mijooPopupShown', 'true');
      }, 8000); 
    }
  });
  function closePopup() {
    const popupOverlay = document.getElementById('popup');
    const popupContent = popupOverlay.querySelector('.popup-content');
    popupContent.classList.add('zoom-out');
    setTimeout(() => {
      popupOverlay.style.display = 'none';
    }, 500); 
  }
  document.getElementById('closePopup').addEventListener('click', closePopup);
  document.querySelector('.popup-text button').addEventListener('click', closePopup);
 /*------------  newslatter popup js end -----------------*/
 
/*------------------ header animation js start -------------------------*/

window.addEventListener('load', function() {

    const items = document.querySelectorAll('.section-header');

    function animateOnScroll() {

        items.forEach(item => {

            const rect = item.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            if(rect.top < windowHeight - 100){
                item.classList.add('show-animation');
            } else {
                item.classList.remove('show-animation');
            }

        });

    }

    animateOnScroll();

    window.addEventListener('scroll', animateOnScroll);
    window.addEventListener('resize', animateOnScroll);

});

/*------------------ header animation js end -------------------------*/